import { useNavigate } from "react-router-dom";

import { getStaffCateItem } from "@/api/staff";
import type { StaffCateItem } from "@/api/staff";
import { useLoadMore } from "@/hooks/useLoadMore";

import { CateItem } from "./CateItem";

const BRAND = "#FF6B35";

export default function EditItemPage() {
  const navigate = useNavigate();

  // 使用公共 hook 处理分页滚动加载
  const {
    list,
    loading,
    hasMore,
    containerRef,
  } = useLoadMore<StaffCateItem>({
    fetcher: async (page) => {
      const res = await getStaffCateItem({ limit: 10, page });
      return {
        list: res.list || [],
        total: res.count || 0,
        page: page,
        limit: 10,
      };
    },
    pageSize: 10,
  });

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header — 品牌橙色 */}
      <div style={{ background: BRAND }}>
        <div className="px-5 flex items-center gap-3" style={{ paddingTop: "calc(env(safe-area-inset-top,0px) + 16px)", paddingBottom: 13 }}>
          <button onClick={() => navigate(-1)} className="w-9 h-9 flex items-center justify-center rounded-full cursor-pointer active:scale-[0.98] shrink-0" style={{ background: "rgba(255,255,255,0.2)" }}>
            <i className="ri-arrow-left-line" style={{ fontSize: 20, color: "#fff" }} />
          </button>
          <span className="text-lg font-bold text-white">项目申请</span>
        </div>
      </div>

      {/* 列表区域 */}
      <div ref={containerRef} className="bg-white" style={{ height: "calc(100vh - 60px)", overflowY: "auto" }}>
        {list.length > 0 ? (
          <div className="px-[15px] py-[15px]">
            {list.map((item) => (
              <CateItem key={item.id} item={item} />
            ))}
            {!hasMore && !loading && (
              <div className="py-4 text-center text-xs text-gray-300">— 已加载全部 —</div>
            )}
          </div>
        ) : null}

        {loading && (
          <div className="py-10 text-center text-xs text-gray-400">
            <i className="ri-loader-4-line text-xl animate-spin block mx-auto mb-2" />
            加载中...
          </div>
        )}

        {!loading && list.length === 0 && (
          <div className="pt-[60px] text-center">
            <i className="ri-apps-line text-5xl block mx-auto mb-3 text-gray-200" />
            <p className="text-sm text-gray-400">暂无可申请的项目</p>
          </div>
        )}
      </div>
    </div>
  );
}
